export function fmtPrice(n) {
  if (n == null || !Number.isFinite(n)) return '—';
  if (n >= 1000) return n.toLocaleString(undefined, { maximumFractionDigits: 2 });
  if (n >= 1) return n.toFixed(4);
  return n.toFixed(6);
}

/** USD-style price label with $ prefix (Mark, bid/ask, etc.) */
export function fmtDollar(n) {
  const p = fmtPrice(n);
  return p === '—' ? p : `$${p}`;
}

/** Spread / small delta with $ prefix — not full price formatting. */
export function fmtSpread(value, { spreadStep, dollar = true } = {}) {
  if (value == null || !Number.isFinite(value)) return '—';
  const step = spreadStep || 0.01;
  let decimals = 4;
  if (step >= 10) decimals = 0;
  else if (step >= 1) decimals = 2;
  else if (step >= 0.1) decimals = 3;
  else if (step >= 0.01) decimals = 4;
  const text = value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  });
  return dollar ? `$${text}` : text;
}

export function fmtUsd(n) {
  if (n == null || !Number.isFinite(n)) return '—';
  return `$${Number(n).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/** App display timezone (Central — CST/CDT automatically) */
export const DISPLAY_TZ = 'America/Chicago';

/** SQLite UTC datetime → Central time with label */
export function fmtSignalTime(isoOrSql) {
  if (!isoOrSql) return '—';
  const normalized = String(isoOrSql).includes('T')
    ? isoOrSql
    : `${String(isoOrSql).replace(' ', 'T')}Z`;
  const d = new Date(normalized);
  if (Number.isNaN(d.getTime())) return isoOrSql;
  const formatted = d.toLocaleString('en-US', {
    timeZone: DISPLAY_TZ,
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short',
  });
  return formatted;
}
